enum QuickEnum {
    NONE = "",
    /* 有买家留言 */
    QUICK_HAS_BUYER_REMARK = "QUICK_HAS_BUYER_REMARK",
    /* 有卖家留言 */
    QUICK_HAS_SELLER_REMARK = "QUICK_HAS_SELLER_REMARK",
    /* 货到付款订单 */
    QUICK_CASH_DELIVERY = "QUICK_CASH_DELIVERY",
    /* 在线支付订单 */
    QUICK_ONLINE_PAY = "QUICK_ONLINE_PAY",
    /* 合并订单 */
    QUICK_MERGE_PARENT_ORDER = "QUICK_MERGE_PARENT_ORDER",
    /* 镇乡村订单 */
    QUICK_COUNTRY_ORDER = "QUICK_COUNTRY_ORDER",
    /* 非乡村镇订单 */
    QUICK_NO_COUNTRY_ORDER = "QUICK_NO_COUNTRY_ORDER",
    /* 有买家留言 或 卖家备注 */
    QUICK_HAS_ANY_REMARK = "QUICK_HAS_ANY_REMARK",
    /* 无备注 或 无留言 */
    QUICK_HAS_NO_REMARK = "QUICK_HAS_NO_REMARK",
    /* 有代发备注 */
    QUICK_HAS_SUPPLIER_REMARK = "QUICK_HAS_SUPPLIER_REMARK",
    /* 需手工合并订单 */
    QUICK_MANUAL_MERGER = "QUICK_MANUAL_MERGER",
    /** 拆分订单 */
    QUICK_SPLIT_CHILD_ORDER = "QUICK_SPLIT_CHILD_ORDER",
    /* 非合并订单 */
    QUICK_NOT_MERGE_ORDER = "QUICK_NOT_MERGE_ORDER",
    /* 非自提订单 */
    QUICK_NO_SELF_PICKUP = "QUICK_NO_SELF_PICKUP",
    /* 部分发货 */
    QUICK_PART_SHIP = "QUICK_PART_SHIP",
    /** 部分取消 */
    QUICK_PART_CANCELED = "QUICK_PART_CANCELED",
    /* 已录入运单号 */
    QUICK_WAYBILL_NO_INPUTED = "QUICK_WAYBILL_NO_INPUTED",
    /* 未录入运单号 */
    QUICK_WAYBILL_NO_UNINPUTED = "QUICK_WAYBILL_NO_UNINPUTED",
    /**
     * 加运费发顺丰(拼多多)
     * @deprecated 通过orderTags查询
     */
    QUICK_SHIP_BY_SF = "QUICK_SHIP_BY_SF",
    /**
     * 指定物流（拼多多）
     * @deprecated 通过orderTags查询
     */
    QUICK_DESIGNATED_LOGISTICS_COMPANY = "QUICK_DESIGNATED_LOGISTICS_COMPANY",
    /** 有赠品(拼多多) */
    QUICK_HAS_GIFT = "QUICK_HAS_GIFT",
    /** 包邮订单 */
    QUICK_SHIPPING_FEE = "QUICK_SHIPPING_FEE",
    /** 运费大于0 */
    QUICK_HAS_SHIPPING_FEE = "QUICK_HAS_SHIPPING_FEE",
    /** 即将发货超时 */
    QUICK_DELIVERY_TIMEOUT = "QUICK_DELIVERY_TIMEOUT",
    /** 非京仓订单 */
    QUICK_NOT_JD_FULFILLMENT = "QUICK_NOT_JD_FULFILLMENT",
    /**
     * 可延迟发货(PDD)
     * @deprecated 通过orderTags查询
     */
    QUICK_REGION_BLACK_DELAY_SHIPPING = "QUICK_REGION_BLACK_DELAY_SHIPPING",
    /**
     * 催发货(PDD,TB)
     * @deprecated 通过orderTags查询
     */
    QUICK_EXPEDITE_DELIVERY = "QUICK_EXPEDITE_DELIVERY",
    /**
     * 阿里 发货即将超时
     * @deprecated 通过orderTags查询
     */
    QUICK_SEND_ABOUT_TO_OVERDUE = "QUICK_SEND_ABOUT_TO_OVERDUE",
    /**
     * 阿里官方直送
     * @deprecated 通过orderTags查询
     */
    QUICK_ALI_DELIVERY_GUARANTEE = "QUICK_ALI_DELIVERY_GUARANTEE",
    /** 单款单件 */
    QUICK_SINGLE_SKU_SINGLE_PIECE = "QUICK_SINGLE_SKU_SINGLE_PIECE",
    /** 单款多件 */
    QUICK_SINGLE_SKU_MULTI_PIECE = "QUICK_SINGLE_SKU_MULTI_PIECE",
    /** 多款多件 */
    QUICK_MULTI_SKU = "QUICK_MULTI_SKU",
    /** 多运单号 */
    QUICK_MULTI_WAYBILL = "QUICK_MULTI_WAYBILL",
    /**
     * 回收运单号
     * @description 通过orderTags查询
     */
    QUICK_CANCEL_WAYBILL_RECYCLED = "QUICK_CANCEL_WAYBILL_RECYCLED",

    QUICK_SHIPPING_DEADLINE_OVERDUE = "QUICK_SHIPPING_DEADLINE_OVERDUE",
}

export const deprecatedQuicks = [
    QuickEnum.QUICK_ALI_DELIVERY_GUARANTEE,
    QuickEnum.QUICK_EXPEDITE_DELIVERY,
    QuickEnum.QUICK_REGION_BLACK_DELAY_SHIPPING,
    QuickEnum.QUICK_SEND_ABOUT_TO_OVERDUE,
    QuickEnum.QUICK_SHIP_BY_SF,
    QuickEnum.QUICK_DESIGNATED_LOGISTICS_COMPANY,
];

export default QuickEnum;
